var template = document.createElement("template");
template.innerHTML = `
    <button class="button" type="button" data-info-modal-open></button>
`;

if (!customElements.get('info-modal-button')) {
    class InfoModalButton extends HTMLElement {
        constructor() {
            super();
            // this.attachShadow({ mode: "open" });
            // this.appendChild(template.content.cloneNode(true));
            this.insertAdjacentHTML('afterbegin', `
                <button class="button ${this.getAttribute('data-classes')}" type="button" data-info-modal-open></button>
            `);
        }

        connectedCallback() {
            if (this.getAttribute("data-template-id")) {
                this.querySelector("button[data-info-modal-open]").setAttribute("data-template-id", this.getAttribute("data-template-id"));
            }

            if (this.getAttribute("text")) {
                this.querySelector("button[data-info-modal-open]").innerHTML =  this.getAttribute("text");
            }
            if (this.getAttribute("icon-background")) {
                this.querySelectorAll(".tooltip-icon path").forEach(icon => {
                    icon.style.fill = this.getAttribute("icon-background");
                })
            }
            if(!this.getAttribute('has-event-listener')) {
                this.setupEventListeners();
            }
        }


        setupEventListeners() {
            const templateId = this.querySelector("button[data-info-modal-open]").getAttribute('data-template-id');
            this.setAttribute('has-event-listener', true);
            this.querySelector("button[data-info-modal-open]").addEventListener('click', e => {
                const templateElem = document.getElementById(templateId).content.cloneNode(true);
                document.getElementById('info-modal').openWith(templateElem);
            });
        }
    }

    window.customElements.define("info-modal-button", InfoModalButton);

}